<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tscheduleaccountoperate}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-date-picker
            v-model="dataForm.createDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="录入日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <!-- <wList
            v-model="dataForm.companyId"
            dataUrl="/sys/companies/list"
            placeholder="公司"
          ></wList> -->
          <wList v-model="dataForm.companyId"  type="1" dataUrl= "/sys/tscheduleaccountoperate/getCompanyList" placeholder="公司名称"></wList>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.reviewersStatus" clearable placeholder="状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tscheduleaccountoperate:save')" type="primary" @click="addOrUpdateHandle()">{{
            $t("add")
          }}</el-button> 
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:tscheduleaccountoperate:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @sort-change="dataListSortChangeHandle($event,false)"
      >
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->

        <el-table-column
          prop="companyName"
          label="公司"
          header-align="center"
          align="center"
        
        ></el-table-column>
        <el-table-column
          prop="amount"
          label="充值金额（元）"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="reviewersStatus"
          label="状态"
          header-align="center"
          align="center"
          sortable="custom"
        >
        <template slot-scope="scope">
            <div>
              <span v-if="scope.row.reviewersStatus == 0">待审核</span>
              <span v-if="scope.row.reviewersStatus == 1">审核通过</span>
              <span v-if="scope.row.reviewersStatus == 2">待修改</span>
            </div>
          </template>
      </el-table-column>
      <el-table-column
          prop="status"
          label="是否有效"
          header-align="center"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.status == 0">无效</span>
              <span v-if="scope.row.status == 1">有效</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="录入时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="reviewersDate"
          label="复核时间"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="录入人"
          header-align="center"
          align="center"
        
        ></el-table-column>
        <el-table-column
          prop="reviewersName"
          label="复核人"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
        <template slot-scope="scope">
            <el-button v-if="scope.row.reviewersStatus == 0 && $hasPermission('sys:tscheduleaccountoperate:audit')" type="text" size="small" @click="editStatus(scope.row,'/sys/tscheduleaccountoperate/audit',1)">通过</el-button>
            <el-button v-if="scope.row.reviewersStatus == 0 && $hasPermission('sys:tscheduleaccountoperate:audit')" type="text" size="small" @click="editStatus(scope.row,'/sys/tscheduleaccountoperate/audit',2)">不通过</el-button>
            <el-button
             v-if="scope.row.reviewersStatus == 2 && $hasPermission('sys:tscheduleaccountoperate:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./tscheduleaccountoperate-add-or-update";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/tscheduleaccountoperate/page",
        getDataListIsPage: true,
        exportURL: "/sys/tscheduleaccountoperate/export",
        deleteURL: "/sys/tscheduleaccountoperate",
        deleteIsBatch: true,
      },
      statusList: [
        {
          label: "待复核",
          value: 0,
        },
        {
          label: "通过",
          value: 1,
        },
        {
          label: "未通过",
          value: 2,
        },
      ],
      dataForm: {
        id: "",
        company: "",
        reviewersStatus: "",
        companyId: '',
      },
    };
  },
  components: {
    AddOrUpdate,
  },
};
</script>
